import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { MutableCoroutineContext2j9pn5zmhi2pt as MutableCoroutineContext } from './MutableCoroutineContext.mjs';
import { Dispatchers_getInstanceitgtkvqfcnx3 as Dispatchers_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import {
  get_keyp54t1phutrkg as get_key,
  StatusListener1jkchgp0onou6 as StatusListener,
  Key_instance6wd16m35aua5 as Key_instance,
  onRemove3k528udkni1ni as onRemove,
} from '../../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  get6d5x931vk0s as get,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
  plusolev77jfy5r9 as plus,
  Element2gr7ezmxqaln7 as Element,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContext.mjs';
import { AbstractCoroutineContextElement2rpehg0hv5szw as AbstractCoroutineContextElement } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { Key_instance2ye2t23iqghop as Key_instance_0 } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineExceptionHandler.mjs';
import {
  report1vfr9zf0i9d9p as report,
  get_viewDebugTarget2umd1p7wjmzxt as get_viewDebugTarget,
  checkLeakAfterDelayr9e6vxihbhwn as checkLeakAfterDelay,
} from '../debugger.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { ViewWriter2xfqkrnuqv5cx as ViewWriter } from './ViewWriter.mjs';
import {
  Align_Stretch_getInstancecei5ndh62f1w as Align_Stretch_getInstance,
  Dimensions32ju1l7z4mh as Dimension,
} from '../models/data.mjs';
import {
  Companion_getInstance1350ksylxva5s as Companion_getInstance,
  Companion_getInstance31w1ky5wvnamo as Companion_getInstance_0,
  WorkingSemantic_getInstance38e4ialv1t20v as WorkingSemantic_getInstance,
  LoadingSemantic_getInstance2bll1ncm1bbe7 as LoadingSemantic_getInstance,
} from '../models/Theme.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { SupervisorJobythnfxkr3jxc as SupervisorJob } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Supervisor.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { RView1jxdnn5qf89cm as RView } from './RView.commonHtml.mjs';
import {
  Edges2jf5wl855ambv as Edges,
  Companion_getInstance2eccs74uj90kl as Companion_getInstance_1,
} from '../models/Rect.mjs';
import { minOf33o15vox9quzb as minOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/_ComparisonsJs.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  get_indices3txodfl5wuu5j as get_indices,
  get_lastIndex1yw0x4k50k51w as get_lastIndex,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { removeAll3o43e67jmwdpc as removeAll } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import {
  ExceptionHandlers355q12ugblzqr as ExceptionHandlers,
  Companion_getInstanceghpsqwa00d1o as Companion_getInstance_2,
  Companion_getInstance37g5wqg3e7ywq as Companion_getInstance_3,
} from '../exceptions/handling.mjs';
import {
  _ReactiveState___get_raw__impl__92ipya10f5f3x6hwqt0 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveNotReadygki7zhqkkp9u as InternalReactiveNotReady,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
} from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { addAndRunListener8g331b1wn43q as addAndRunListener } from '../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import {
  WeakReferencel11chldcck68 as WeakReference,
  identityHashCodemue8eqr5m304 as identityHashCode,
} from '../debugger.js.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { removePrefix279df90bhrqqg as removePrefix } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { toString1h6jjoch8cjt8 as toString_1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.xd8_1 = false;
        this.yd8_1 = false;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_4() {
  return Companion_instance;
}
function _set_themeAndBack__2re99a($this, value) {
  if (!value.equals($this.pb6_1)) {
    $this.pb6_1 = value;
    $this.sb9(value);
    $this.kb9();
    var _iterator__ex2g4s = $this.sb6_1.m1();
    while (_iterator__ex2g4s.n1()) {
      var child = _iterator__ex2g4s.o1();
      child.mba();
    }
  }
}
function _set_loadCount__8vrevw($this, value) {
  $this.wb6_1 = value;
  if (value === 0 && $this.vb6_1.f2()) {
    $this.vb6_1.mam(false);
    $this.mba();
  } else if (value > 0 && !$this.vb6_1.f2()) {
    $this.vb6_1.mam(true);
    $this.mba();
  }
}
function _set_workCount__2dqm0p($this, value) {
  $this.yb6_1 = value;
  if (value === 0 && $this.xb6_1.f2()) {
    $this.xb6_1.mam(false);
    $this.mba();
  } else if (value > 0 && !$this.xb6_1.f2()) {
    $this.xb6_1.mam(true);
    $this.mba();
  }
}
function contextSetup($this) {
  // Inline function 'kotlin.apply' call
  var this_0 = new (MutableCoroutineContext())();
  this_0.wd8($this.zb6_1);
  // Inline function 'kotlinx.coroutines.CoroutineExceptionHandler' call
  var tmp$ret$0 = new (RViewHelper$contextSetup$$inlined$apply$1())(this_0);
  this_0.wd8(tmp$ret$0);
  this_0.wd8(new (RViewHelper$contextSetup$1())($this));
  this_0.wd8(Dispatchers_getInstance().zac().tac());
  return this_0;
}
function exceptionToMessage$handle(myView, $exception, view) {
  var tmp0_safe_receiver = view.ub6_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.zcv(myView, $exception);
  var tmp;
  if (tmp1_elvis_lhs == null) {
    var tmp2_safe_receiver = view.rb6_1;
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = exceptionToMessage$handle(myView, $exception, tmp2_safe_receiver);
    }
    tmp = tmp_0;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  return tmp;
}
function RViewHelper$clearChildren$lambda(it) {
  it.nba(null);
  it.la9();
  return true;
}
var RViewHelper$contextSetup$1Class;
function RViewHelper$contextSetup$1() {
  if (RViewHelper$contextSetup$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.zd8_1 = this$0;
      }
      dah(reactive) {
        this.zd8_1.wba(reactive);
      }
      cah(reactive) {
        this.zd8_1.xba(reactive);
      }
    }
    protoOf($).e2 = get_key;
    protoOf($).cd = get;
    protoOf($).fp = fold;
    protoOf($).ep = minusKey;
    protoOf($).gp = plus;
    initMetadataForClass($, VOID, VOID, VOID, [StatusListener()]);
    RViewHelper$contextSetup$1Class = $;
  }
  return RViewHelper$contextSetup$1Class;
}
var RViewHelper$contextSetup$$inlined$apply$1Class;
function RViewHelper$contextSetup$$inlined$apply$1() {
  if (RViewHelper$contextSetup$$inlined$apply$1Class === VOID) {
    class $ extends AbstractCoroutineContextElement() {
      constructor($$this$apply, $box) {
        if ($box === VOID)
          $box = {};
        $box.bd9_1 = $$this$apply;
        super(Key_instance_0, $box);
      }
      wa8(context, exception) {
        if (!(exception instanceof CancellationException())) {
          report(exception, toString(this.bd9_1));
        }
        return Unit_instance;
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [AbstractCoroutineContextElement(), Element()]);
    RViewHelper$contextSetup$$inlined$apply$1Class = $;
  }
  return RViewHelper$contextSetup$$inlined$apply$1Class;
}
function invoke$_anonymous_$_anonymous_$handle_4cljpa(myView, $it, view) {
  var tmp0_safe_receiver = view.tb6_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qcv(myView, true, $it);
  var tmp;
  if (tmp1_elvis_lhs == null) {
    var tmp2_safe_receiver = view.rb6_1;
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = invoke$_anonymous_$_anonymous_$handle_4cljpa(myView, $it, tmp2_safe_receiver);
    }
    tmp = tmp_0;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  return tmp;
}
function invoke$_anonymous_$_anonymous_$handle_4cljpa_0(myView, $it, view) {
  var tmp0_safe_receiver = view.tb6_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qcv(myView, false, $it);
  var tmp;
  if (tmp1_elvis_lhs == null) {
    var tmp2_safe_receiver = view.rb6_1;
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = invoke$_anonymous_$_anonymous_$handle_4cljpa_0(myView, $it, tmp2_safe_receiver);
    }
    tmp = tmp_0;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  return tmp;
}
var RViewHelperClass;
function RViewHelper() {
  if (RViewHelperClass === VOID) {
    class $ extends ViewWriter() {
      constructor(context) {
        super();
        this.yb5_1 = context;
        this.zb5_1 = false;
        this.ab6_1 = 1.0;
        this.bb6_1 = true;
        this.cb6_1 = true;
        this.db6_1 = null;
        this.eb6_1 = false;
        this.fb6_1 = null;
        this.gb6_1 = null;
        this.hb6_1 = null;
        this.ib6_1 = null;
        this.jb6_1 = Align_Stretch_getInstance();
        this.kb6_1 = Align_Stretch_getInstance();
        this.lb6_1 = null;
        this.mb6_1 = null;
        this.nb6_1 = false;
        this.ob6_1 = Companion_getInstance().xd1_1;
        this.pb6_1 = Companion_getInstance_0().od1_1.yb0_1;
        this.qb6_1 = false;
        this.rb6_1 = null;
        this.sb6_1 = ArrayList().w();
        this.tb6_1 = null;
        this.ub6_1 = null;
        this.vb6_1 = Signal().fak(false);
        this.wb6_1 = 0;
        this.xb6_1 = Signal().fak(false);
        this.yb6_1 = 0;
        this.zb6_1 = SupervisorJob();
        this.ab7_1 = contextSetup(this);
        this.bb7_1 = null;
        this.cb7_1 = null;
      }
      pc() {
        return this.yb5_1;
      }
      aba() {
        return this instanceof RView() ? this : THROW_CCE();
      }
      eb7(_set____db54di) {
        this.ab6_1 = _set____db54di;
      }
      gb7() {
        return this.ab6_1;
      }
      hb7(_set____db54di) {
        this.bb6_1 = _set____db54di;
      }
      wb8() {
        return this.bb6_1;
      }
      bba(value) {
        this.hb7(value);
      }
      cba() {
        return this.wb8();
      }
      xb8(_set____db54di) {
        this.cb6_1 = _set____db54di;
      }
      yb8() {
        return this.cb6_1;
      }
      zb8(_set____db54di) {
        this.db6_1 = _set____db54di;
      }
      bb9() {
        return this.db6_1;
      }
      dba(value) {
        this.zb8(value);
      }
      cb9(_set____db54di) {
        this.eb6_1 = _set____db54di;
      }
      eba(value) {
        var tmp;
        var tmp_0 = value;
        if ((tmp_0 == null ? null : new (Dimension())(tmp_0)) == null) {
          tmp = null;
        } else {
          var tmp_1 = value;
          // Inline function 'kotlin.let' call
          var p0 = (tmp_1 == null ? null : new (Dimension())(tmp_1)).wb1_1;
          tmp = Edges().ad0(p0);
        }
        this.hba(tmp);
      }
      fba() {
        var tmp0_safe_receiver = this.mb9();
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kb2_1;
      }
      gba(value) {
        this.fb6_1 = value;
        this.kb9();
      }
      hba(value) {
        this.gb6_1 = value;
        this.kb9();
      }
      mb9() {
        return this.gb6_1;
      }
      gb9(_set____db54di) {
        this.lb6_1 = _set____db54di;
      }
      hb9() {
        return this.lb6_1;
      }
      ib9(_set____db54di) {
        this.mb6_1 = _set____db54di;
      }
      jb9() {
        return this.mb6_1;
      }
      iba(value) {
        this.nb6_1 = value;
        this.mba();
      }
      jba(value) {
        this.ob6_1 = value;
        this.mba();
      }
      kba() {
        return this.pb6_1.eb1_1;
      }
      tb9() {
        var tmp0_elvis_lhs = this.fba();
        var tmp;
        var tmp_0 = tmp0_elvis_lhs;
        if ((tmp_0 == null ? null : new (Dimension())(tmp_0)) == null) {
          tmp = this.pb6_1.eb1_1.ib0_1.lb2_1;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var pad = tmp;
        var tmp1_elvis_lhs = this.bb9();
        var tmp_1;
        var tmp_2 = tmp1_elvis_lhs;
        if ((tmp_2 == null ? null : new (Dimension())(tmp_2)) == null) {
          tmp_1 = this.pb6_1.eb1_1.hb0_1;
        } else {
          tmp_1 = tmp1_elvis_lhs;
        }
        var gap = tmp_1;
        return minOf(new (Dimension())(pad), new (Dimension())(gap)).wb1_1;
      }
      lb9() {
        var tmp0_elvis_lhs = this.mb9();
        // Inline function 'kotlin.let' call
        var it = tmp0_elvis_lhs == null ? this.pb6_1.gb1_1 ? this.kba().ib0_1 : Companion_getInstance_1().zcz_1 : tmp0_elvis_lhs;
        return !(this.fb6_1 == null) ? it.plusEdgesNullable(this.fb6_1) : it;
      }
      lba(theme) {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.let' call
        var it = this.db7().f2() ? theme.db1(WorkingSemantic_getInstance()) : theme;
        return this.uba().f2() ? it.db1(LoadingSemantic_getInstance()) : it;
      }
      kb9() {
      }
      mba() {
        if (equals(this, get_viewDebugTarget())) {
          println('refreshTheming');
        }
        if (!this.qb6_1) {
          if (equals(this, get_viewDebugTarget())) {
            println('refreshTheming abandoned due to not fullyStarted');
          }
          return Unit_instance;
        }
        var tmp0_safe_receiver = this.rb6_1;
        if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qb6_1) === false) {
          if (equals(this, get_viewDebugTarget())) {
            println('refreshTheming abandoned due to parent ' + toString_0(this.rb6_1) + ' not being fully started');
          }
          return Unit_instance;
        }
        var tmp;
        if (this.nb6_1) {
          var tmp1_safe_receiver = this.rb6_1;
          var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.kba();
          tmp = tmp2_elvis_lhs == null ? Companion_getInstance_0().od1_1 : tmp2_elvis_lhs;
        } else {
          var tmp3_safe_receiver = this.rb6_1;
          var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.kba();
          var tmp_0;
          if (tmp4_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            var tmp0_elvis_lhs = tmp4_safe_receiver.wb0_1;
            tmp_0 = tmp0_elvis_lhs == null ? tmp4_safe_receiver : tmp0_elvis_lhs;
          }
          var tmp5_elvis_lhs = tmp_0;
          tmp = tmp5_elvis_lhs == null ? Companion_getInstance_0().od1_1 : tmp5_elvis_lhs;
        }
        var themeBorrowed = tmp;
        if (equals(this, get_viewDebugTarget())) {
          println('refreshTheming will set!  Parent theme is ' + themeBorrowed.db0_1);
        }
        var t = this.lba(this.ob6_1.fd1(themeBorrowed));
        if (equals(this, get_viewDebugTarget())) {
          println('refreshTheming will set to ' + t.eb1_1.db0_1 + '!');
        }
        _set_themeAndBack__2re99a(this, t);
      }
      nba(value) {
        this.rb6_1 = value;
        if (!(this.rb6_1 == null)) {
          this.mba();
        }
      }
      oba() {
        return this.sb6_1;
      }
      pba(view) {
        if (this.zb5_1) {
          println('WARNING!! ' + this.toString() + ' is shut down, but attempt to call willAddChild was made');
        }
        view.nba(this instanceof RView() ? this : THROW_CCE());
      }
      qba(index, view) {
        if (this.zb5_1) {
          println('WARNING!! ' + this.toString() + ' is shut down, but attempt to call addChild was made');
        }
        if (!(view.rb6_1 === this)) {
          view.nba(this instanceof RView() ? this : THROW_CCE());
        }
        this.sb6_1.y3(index, view);
        this.ub9(index, view);
      }
      rba(view) {
        if (this.zb5_1) {
          println('WARNING!! ' + this.toString() + ' is shut down, but attempt to call addChild was made');
        }
        if (!(view.rb6_1 === this)) {
          view.nba(this instanceof RView() ? this : THROW_CCE());
        }
        var index = this.oba().p1();
        this.sb6_1.y3(index, view);
        this.ub9(index, view);
      }
      xb9(index) {
        if (this.zb5_1) {
          println('WARNING!! ' + this.toString() + ' is shut down, but attempt to call removeChild was made');
        }
        if (!(0 <= index ? index <= (this.oba().p1() - 1 | 0) : false))
          throw IllegalArgumentException().a1('' + index + ' not in range ' + get_indices(this.oba()).toString());
        this.wb9(index);
        // Inline function 'kotlin.also' call
        this.sb6_1.z3(index).la9();
      }
      sba(view) {
        if (this.zb5_1) {
          println('WARNING!! ' + this.toString() + ' is shut down, but attempt to call removeChild was made');
        }
        var i = this.oba().s1(view);
        if (!(i === -1)) {
          this.xb9(i);
        } else {
          throw IllegalStateException().o4(view.toString() + ' is not a child of ' + this.toString() + '!');
        }
      }
      zb9() {
        if (this.zb5_1) {
          println('WARNING!! ' + this.toString() + ' is shut down, but attempt call to was made ');
        }
        this.yb9();
        removeAll(this.sb6_1, RViewHelper$clearChildren$lambda);
      }
      tba(exceptionHandler) {
        var tmp0_safe_receiver = this.tb6_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp0_safe_receiver.tba(exceptionHandler);
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = this;
          // Inline function 'kotlin.apply' call
          var this_0 = new (ExceptionHandlers())();
          this_0.tba(exceptionHandler);
          tmp_0.tb6_1 = this_0;
        }
      }
      uba() {
        return this.vb6_1;
      }
      db7() {
        return this.xb6_1;
      }
      ea2() {
        return this.ab7_1;
      }
      vba() {
        return this.ea2().ep(Key_instance);
      }
      wba(readable) {
        var loading = {_v: false};
        var excEnder = {_v: null};
        var r = addAndRunListener(readable, () => {
          // Inline function 'com.lightningkite.kiteui.onMainThread' call
          var s = readable.qah();
          var tmp = loading._v;
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
          var tmp_0 = _ReactiveState___get_raw__impl__92ipya(s);
          if (!(tmp === !!(tmp_0 instanceof InternalReactiveNotReady()))) {
            // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
            var tmp_1 = _ReactiveState___get_raw__impl__92ipya(s);
            if (!(tmp_1 instanceof InternalReactiveNotReady())) {
              var _unary__edvuaz = this.yb6_1;
              _set_workCount__2dqm0p(this, _unary__edvuaz - 1 | 0);
            } else {
              var _unary__edvuaz_0 = this.yb6_1;
              _set_workCount__2dqm0p(this, _unary__edvuaz_0 + 1 | 0);
            }
            // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
            var tmp_2 = _ReactiveState___get_raw__impl__92ipya(s);
            var tmp$ret$2 = !(tmp_2 instanceof InternalReactiveNotReady());
            loading._v = !tmp$ret$2;
          }
          var tmp0_safe_receiver = excEnder._v;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver();
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.exception' call
          var tmp_3 = _ReactiveState___get_raw__impl__92ipya(s);
          var tmp0_safe_receiver_0 = tmp_3 instanceof InternalReactiveThrownException() ? tmp_3 : null;
          var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.sah_1;
          if (tmp1_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            var myView = this instanceof RView() ? this : THROW_CCE();
            var tmp0_elvis_lhs = invoke$_anonymous_$_anonymous_$handle_4cljpa(myView, tmp1_safe_receiver, myView);
            var tmp1_safe_receiver_0 = tmp0_elvis_lhs == null ? Companion_getInstance_2().wcv_1.qcv(myView, true, tmp1_safe_receiver) : tmp0_elvis_lhs;
            if (tmp1_safe_receiver_0 == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              excEnder._v = tmp1_safe_receiver_0;
            }
          }
          return Unit_instance;
        });
        onRemove(this, r);
        return r;
      }
      xba(readable) {
        var loading = {_v: false};
        var excEnder = {_v: null};
        var r = addAndRunListener(readable, () => {
          // Inline function 'com.lightningkite.kiteui.onMainThread' call
          var s = readable.qah();
          var tmp = loading._v;
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
          var tmp_0 = _ReactiveState___get_raw__impl__92ipya(s);
          if (!(tmp === !!(tmp_0 instanceof InternalReactiveNotReady()))) {
            // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
            var tmp_1 = _ReactiveState___get_raw__impl__92ipya(s);
            if (!(tmp_1 instanceof InternalReactiveNotReady())) {
              var _unary__edvuaz = this.wb6_1;
              _set_loadCount__8vrevw(this, _unary__edvuaz - 1 | 0);
            } else {
              var _unary__edvuaz_0 = this.wb6_1;
              _set_loadCount__8vrevw(this, _unary__edvuaz_0 + 1 | 0);
            }
            // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
            var tmp_2 = _ReactiveState___get_raw__impl__92ipya(s);
            var tmp$ret$2 = !(tmp_2 instanceof InternalReactiveNotReady());
            loading._v = !tmp$ret$2;
          }
          var tmp0_safe_receiver = excEnder._v;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver();
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.exception' call
          var tmp_3 = _ReactiveState___get_raw__impl__92ipya(s);
          var tmp0_safe_receiver_0 = tmp_3 instanceof InternalReactiveThrownException() ? tmp_3 : null;
          var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.sah_1;
          if (tmp1_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            var myView = this instanceof RView() ? this : THROW_CCE();
            var tmp0_elvis_lhs = invoke$_anonymous_$_anonymous_$handle_4cljpa_0(myView, tmp1_safe_receiver, myView);
            var tmp1_safe_receiver_0 = tmp0_elvis_lhs == null ? Companion_getInstance_2().wcv_1.qcv(myView, false, tmp1_safe_receiver) : tmp0_elvis_lhs;
            if (tmp1_safe_receiver_0 == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              excEnder._v = tmp1_safe_receiver_0;
            }
          }
          return Unit_instance;
        });
        onRemove(this, r);
        return r;
      }
      yba(exception) {
        var myView = this instanceof RView() ? this : THROW_CCE();
        var tmp0_elvis_lhs = exceptionToMessage$handle(myView, exception, myView);
        return tmp0_elvis_lhs == null ? Companion_getInstance_3().hcw_1.zcv(myView, exception) : tmp0_elvis_lhs;
      }
      la9() {
        this.zb6_1.ma3();
        if (Companion_instance.yd8_1) {
          var inductionVariable = get_lastIndex(this.sb6_1);
          if (0 <= inductionVariable)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + -1 | 0;
              this.wb9(index);
              this.sb6_1.z3(index).la9();
            }
             while (0 <= inductionVariable);
        } else {
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = this.sb6_1.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            element.la9();
          }
          this.sb6_1.v3();
        }
        if (Companion_instance.xd8_1) {
          this.qb9();
        }
        this.zb5_1 = true;
        this.nba(null);
      }
      qb9() {
        checkLeakAfterDelay(new (WeakReference())(this), 1000n);
      }
      zba() {
        this.qb6_1 = true;
        this.mba();
      }
      db9(_set____db54di) {
        this.bb7_1 = _set____db54di;
      }
      fb9() {
        return this.bb7_1;
      }
      toString() {
        var tmp0_elvis_lhs = this.fb9();
        return tmp0_elvis_lhs == null ? this.kba().db0_1 + ' ' + removePrefix(toString(getKClassFromExpression(this)), 'class ') + '@' + toString_1(identityHashCode(this), 16) : tmp0_elvis_lhs;
      }
      abb(_this__u8e3s4) {
        return _this__u8e3s4.xbe(this);
      }
    }
    initMetadataForClass($, 'RViewHelper', VOID, VOID, [ViewWriter(), CoroutineScope()]);
    RViewHelperClass = $;
  }
  return RViewHelperClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  RViewHelper as RViewHelpernvzwiwlyoaxk,
};
//endregion

//# sourceMappingURL=RViewHelper.mjs.map
